
const ChristmasEData26 = [
    {
        id: 1,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_1.webp")
    },
    {
        id: 2,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_2.webp")
    },
    {
        id: 3,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_3.webp")
    },
    {
        id: 4,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_4.webp")
    },
    {
        id: 5,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_5.webp")
    },
    {
        id: 6,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_6.webp")
    },
    {
        id: 7,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_7.webp")
    },
    {
        id: 8,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_8.webp")
    },
    {
        id: 9,
        imageSource: require("../../../Assets/Events/2025/Merry-Christmas-2025/Christmas_9.webp")
    },
];

export default ChristmasEData26;